// extracted by mini-css-extract-plugin
export default {"formShippingFee":"Modal_formShippingFee__tAKIX"};